export default __webpack_public_path__ + "static/media/267.eb6c2bea.gif";